import qs from "query-string"

export const setQueryStringWithoutPageReload = (qsValue) => {
  const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + qsValue
  window.history.replaceState({ path: newurl }, "", newurl)
}

export const setQueryStringPushStateWithoutPageReload = (qsValue) => {
  const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + qsValue
  window.history.pushState({ path: newurl }, "", newurl)
}

export const getQueryStringValue = (key, defaultValue, parseOptions = {}, queryString = window.location.search) => {
  const values = qs.parse(queryString, parseOptions)
  return values[key] || defaultValue
}

export const setQueryStringValue = (key, value, queryString = window.location.search) => {
  const values = qs.parse(queryString)
  const newQsValue = qs.stringify({
    ...values,
    [key]: value,
  })
  setQueryStringWithoutPageReload(`?${newQsValue}`)
}

export const setQueryStringValueWithPushState = (key, value, queryString = window.location.search) => {
  const values = qs.parse(queryString)
  const newQsValue = qs.stringify({
    ...values,
    [key]: value,
  })
  setQueryStringPushStateWithoutPageReload(`?${newQsValue}`)
}

export const getQueryStringKeys = (queryString = window.location.search) => {
  return Object.keys(qs.parse(queryString))
}

export const clearQueryParameters = () => {
  const url = window.location.origin + window.location.pathname
  window.history.replaceState(null, "", url)
}
